module.exports = __webpack_public_path__ + "media/images/illustrations/petSitting-48227e834889f9dd935239d208459aeb.svg";